export enum ObjectModelType {
  Acquisition = 'App\\Models\\Acquisition',
  Advisory = 'App\\Models\\Advisory',
  Company = 'App\\Models\\Company',
  Contact = 'App\\Models\\Contact',
  Disposal = 'App\\Models\\Disposal',
  LettingTransaction = 'App\\Models\\LettingTransaction',
  SaleTransaction = 'App\\Models\\SaleTransaction',
  ScheduleMatch = 'App\\Models\\ScheduleMatch',
  SocietyAcquisition = 'App\\Models\\Society\\SocietyAcquisition',
}

export enum ObjectType {
  // Models
  Advisory = 'Advisory',
  Company = 'Company',
  Contact = 'Contact',
  Disposal = 'Disposal',
  LettingTransaction = 'LettingTransaction',
  Notification = 'Notification',
  Property = 'Property',
  Requirement = 'Requirement',
  SaleTransaction = 'SaleTransaction',
  ScheduleMatch = 'ScheduleMatch',
  SocietyAcquisition = 'SocietyAcquisition',
  Viewing = 'Viewing',
  Task = 'Task',
  // Sub Models
  RequirementComment = 'RequirementComment',
  ScheduleMatchComment = 'ScheduleMatchComment',
  ScheduleMatchMessage = 'ScheduleMatchMessage',
  ScheduleMatchViewing = 'ScheduleMatchViewing',
}

export interface ObjectIds {
  contact?: string;
  company?: string;
  disposal?: string;
}

export interface DisposalRelation {
  label: string;
  type: ObjectType.Disposal;
  type_label: string;
  // Records
  disposal_id: number;
}

export interface RequirementRelation {
  label: string;
  type: ObjectType.Requirement;
  type_label: string;
  // Records
  requirement_id: number;
}

export interface ScheduleMatchRelation {
  label: string;
  type: ObjectType.ScheduleMatch;
  type_label: string;
  // Records
  disposal_id: number;
  schedule_match_id: number;
}

export interface ViewingRelation {
  label: string;
  type: ObjectType.Viewing;
  type_label: string;
  // Records
  disposal_id: number;
  schedule_match_id: number;
  task_id: number;
}

export interface PropertyRelation {
  label: string;
  type: ObjectType.Property;
  type_label: string;
  // Records
  property_id: number;
}

export interface CompanyRelation {
  label: string;
  type: ObjectType.Company;
  type_label: string;
  // Records
  company_id: number;
}

export interface ContactRelation {
  label: string;
  type: ObjectType.Contact;
  type_label: string;
  // Records
  contact_id: number;
}

export interface TaskRelation {
  deleted?: boolean;
  label: string;
  type: ObjectType.Task;
  type_label: string;
  // Records
  task_id: number;
}

export type ActivityRelation = CompanyRelation | ContactRelation | DisposalRelation | PropertyRelation | RequirementRelation | ScheduleMatchRelation | TaskRelation | ViewingRelation;
